module.exports = __webpack_public_path__ + "static/media/lyftingar.40b5323a.png";